import React from 'react';
import * as C from "../componentsM/index";
import { Accordion } from "flowbite-react";

const AdmissionRequirements = () => {

    const content = new getContent()

    return (

        <>

            <C.Hero title={"ADMISSION REQUIREMENT"} image={"/hero/14.jpg"} />




            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>

                    <h1 className="text-xl md:text-2xl font-light">
                        Programme Specific Requirements
                    </h1>

                    <p>English is the language of instruction at The International School. All applicants must meet age-appropriate English Language and Literacy, as well as quantitative and analytical skill requirements.</p>

                </div>

                <div className='flex flex-col gap-5 my-12'>

                    <h1 className="text-xl md:text-2xl font-light">
                        English Language and Literacy Requirements
                    </h1>

                    <p>Applicants, regardless of country of origin or citizenship status, must demonstrate competence and literacy in the English language prior to admission. Competence is expected in all four of the following skills: listening, reading, speaking, and writing.
                    </p>

                </div>

                <Accordion collapseAll className='border-0'>


                    {content.accordionData.map((v, i) => <Accordion.Panel key={i}>
                        <Accordion.Title>{v.year}</Accordion.Title>
                        <Accordion.Content className='bg-white'>
                            <ul className="mb-2 text-gray-500 dark:text-gray-400">
                                {v.events.map(c => <li key={c}>{c}</li>)}
                            </ul>
                        </Accordion.Content>
                    </Accordion.Panel>)}


                </Accordion>


            </section>

        </>

    )

}

export default AdmissionRequirements





class getContent {

    accordionData = [
        {
            "year": "English Language and Literacy Requirements",
            "events": [
                "Obtain a grade of 75% or higher in a recognised English Language or Literature Course, modelled on a US or Canadian secondary school system where the language of instruction and examination is English.",
                "Obtain a grade of B or higher in the English Language or Literature Course of UK based O-level, GCSE, or IGCSE qualification where the language of instruction and examination is English.",
                "Obtain an IB grade of 4 or higher in any English Course of an IB World School.",
                "Obtain a grade of 75% or higher in Secondary School Certificate of an IBCC recognised Examination Board in Pakistan.",
                "Applicants with qualifications other than those specified above, must have achieved at least an average achievement level in their respective programmes."
            ]
        },
        {
            "year": "Mathematics Requirements",
            "events": [
                "Obtain a grade of 75% or higher in a recognised Mathematics Course, modelled on a US or Canadian secondary school system where the language of instruction and examination is English.",
                "Obtain a grade of B or higher in the Mathematics Course of UK based O’level, GCSE, or IGCSE qualification where the language of instruction and examination is English.",
                "Obtain an IB grade of 4 or higher in any Mathematics Course of an IB World School.",
                "Obtain a grade of 75% or higher in Secondary School Certificate of an IBCC recognised Examination Board in Pakistan.",
                "Applicants with qualifications other than those specified above, must have achieved at least an average achievement level in their respective programmes."
            ]
        },
        {
            "year": "Diploma Programme",
            "events": [
                "A student must have exceptional prior qualifications in Advanced Mathematics and Sciences to select Higher Level courses for the same, in the Diploma Programme.",
                "In the event that the applicant does not meet this condition, he/she will be required to write a departmental test."
            ]
        },
        {
            "year": "General Intelligence",
            "events": [
                "The General Intelligence placement assessment taken for PYP and MYP applicants has three levels of achievement: below average, average and above average.",
                "Applicants are expected to achieve at least an average score on this assessment."
            ]
        },
        {
            "year": "Class Placement",
            "events": [
                "Students will be placed in their age appropriate year group. This includes the Primary Years Programme (PYP), Middle Years Programme (IB MYP) and the IB Diploma.",
                "Age on 1st August, Class, Section Age",
                "02, Toddlers, IB PYP",
                "03, Nursery, IB PYP",
                "04, Prep 1, IB PYP",
                "05, Prep 2, IB PYP",
                "06, Year 1, (PYP 1) IB PYP",
                "07, Year 2, (PYP 2) IB PYP",
                "08, Year 3, (PYP 3) IB PYP",
                "09, Year 4, (PYP 4) IB PYP",
                "10, Year 5, (PYP 5) IB PYP",
                "11, Year 6, (MYP 1) IB MYP",
                "12, Year 7, (MYP 2) IB MYP",
                "13, Year 8, (MYP 3) IB MYP",
                "14, Year 9, (MYP 4) IB MYP",
                "15, Year 10, (MYP 5) IB MYP",
                "16, Year 11, (DP 1) IB DP",
                "17+, Year 12, (DP 2) IB DP"
            ]
        },
        {
            "year": "Diverse Qualifications",
            "events": [
                "Each term, many more admission applications are received than can be accepted. Academic performance is the main criterion for admission and is used exclusively in 90% of cases.",
                "However, some candidates have other attributes and achievements that should be considered in determining admission. They may:",
                "Demonstrate commitment and/or excellence in other endeavours; or",
                "Present a clear and valid reason for attending TIS; or",
                "Succeed in their studies in spite of difficult circumstances.",
                "TIS will select up to 10% of new students, taking into account these diverse qualifications.",
                "In such cases, the Admissions Committee of the respective programme, reserves the right to offer admission in the class level they deem fit."
            ]
        }
    ]
    


}